import { withTranslation } from "react-i18next";
import CustomersModal from './CustomersModal';

export default withTranslation()(CustomersModal);